var FUNCTION_IDENTIFIER = '@@=';
var CONSTANT_IDENTIFIER = '@@#';
var TYPE_KEY = '@@type';
export { FUNCTION_IDENTIFIER, CONSTANT_IDENTIFIER, TYPE_KEY };
//# sourceMappingURL=syntactic-sugar.js.map